<template>
	<o-card
		class="card--dashboard-not-viewed-doc"
		:gradient="color">
		<o-icon
			class="not-viewed-docs__icon"
			:font-icon="type === 'notViewed' ? 'icon-interface-edit-view' : 'icon-draft'"/>

		<div class="not-viewed-docs">
			<h3
				v-if="setup.newItems.length"
				class="not-viewed-docs__title">
				{{ type === 'notViewed' ? `Vos nouveaux documents` : late ? `Vos documents à signer (hors délai)` : `Vos documents à signer` }}
			</h3>
			<h3
				v-else
				class="not-viewed-docs__title">
				{{ type === 'notViewed' ? `Aucun nouveau document` : late ? `Aucun document à signer (hors délai)` : `Aucun document à signer` }}
			</h3>
			<div
				v-for="doc in setup.newItems"
				:key="doc.type"
				class="not-viewed-doc">
				<div class="not-viewed-doc__type">
					<span class="not-viewed-doc__count">{{ doc.count }}</span> {{ doc.readable(setup.self.isAgency()) }}
				</div>
				<div>
					<o-button
						v-if="doc && setup.canBeViewedByUser(doc.documentType)"
						outline
						block
						color="default"
						@click="setup.handleClick(doc)">
						{{ setup.docButtonLabel(doc) }}
					</o-button>
				</div>
			</div>
		</div>

		<o-loader
			:color="color"
			:visible="!setup.dataLoaded"/>
	</o-card>
</template>

<script setup lang="ts">
import DashboardNewDocOrSignCardSetupService from '@/setup/dashboard/DashboardNewDocOrSignCardSetupService';
const props = defineProps(DashboardNewDocOrSignCardSetupService.props);
const setup = new DashboardNewDocOrSignCardSetupService(props);
</script>


<style scoped lang="less">
.card--dashboard {
	&-not-viewed-doc {
    min-height: 9.3rem;
    height: 100%;

    .not-viewed-docs {
      &__title {
        color: white;
        margin: 0.6rem 0 0.9rem;
        padding: 0.3rem;
      }

      &__icon {
        position: absolute;
        top: 0.9rem;
        right: 0.9rem;
        opacity: 0.15;
        font-size: 7.5rem;
      }
    }

    .not-viewed-doc {
      display: grid;
      grid-template-columns: 2fr 1fr;
      align-items: center;
      gap: 0.5rem;
      padding: 0.3rem;
      font-size: 0.85rem;
      line-height: 1.25rem;
      font-weight: bold;
      text-transform: uppercase;

      &__type {
        display: flex;
        align-items: center;
      }

      &__count {
        transform: translateY(-0.13rem);
        margin-right: 0.6rem;
        font-size: 2.75rem;
        line-height: 1;
        font-weight: bold;
        text-shadow: 0 0.13rem 0.19rem fade(black, 20);
      }
    }
  }
}
</style>
